import styled from "@emotion/styled";
import { ReactNode } from "react";
import { Heading } from "../Heading";

const Section = styled.section`
  display: grid;
  margin: 0 auto;
  padding: 48px 24px;

  @media ${({ theme }) => theme.bp.tabletUp} {
    padding: 64px;
  }

  @media ${({ theme }) => theme.bp.extraWideDesktopUp} {
    grid-template-columns: repeat(2, 1fr);
    flex-direction: row;
    column-gap: 162px;
    padding: 64px 128px;
  }
`;

const Summary = styled.div`
  p {
    line-height: 1.5;
    margin-bottom: 24px;
  }

  ul {
    line-height: 1.5;
    margin-bottom: 24px;
    padding-left: 20px;
  }

  li {
    list-style: disc;
    margin-bottom: 8px;
  }

  a {
    color: ${({ theme }) => theme.colors.charcoal};
    text-decoration: underline;
  }
`;

const Title = styled(Heading)`
  margin-bottom: 32px;
  text-align: left;
`;

export type ImpactShopProductPagePanelProps = {
  className?: string;
  fundBreakdown: ReactNode | null;
  header: string;
  summaryText: string;
  children?: ReactNode;
  link: ReactNode | null;
};

export const ImpactShopProductPagePanel = ({
  className,
  fundBreakdown,
  header,
  summaryText,
  children,
  link,
}: ImpactShopProductPagePanelProps) => {
  return (
    <Section className={className}>
      <div>
        <Title as="h2" size={4}>
          {header}
        </Title>
        <Summary dangerouslySetInnerHTML={{ __html: summaryText }} />
        {fundBreakdown}
        {link}
      </div>
      {children}
    </Section>
  );
};
